import type { ReactElement } from 'react'

import KeywordIcon from './icons/KeywordIcon'
import SubtitleIcon from './icons/SubtitleIcon'
import TitleIcon from './icons/TitleIcon'

export type IconName = 'keyword' | 'subtitle' | 'title'

const icons = (props: Props): Record<IconName, ReactElement> => ({
  keyword: <KeywordIcon {...props} />,
  subtitle: <SubtitleIcon {...props} />,
  title: <TitleIcon {...props} />,
})

export interface Props {
  className?: string
  color?: string
  name: IconName
  onClick?: () => void
  size?: number
}

const Icon = ({ className, color = '#1b1d1f', name, onClick, size = 24 }: Props): ReactElement =>
  icons({ className, color, name, onClick, size })[name]

export default Icon
